module.exports = __webpack_public_path__ + "images/pages/lp/ribon_2bb41edd3775b042da3a6bba535b2e94.png";